<template>
  <div class="profile-header">
    <v-skeleton-loader v-if="loading" type="list-item-avatar-two-line"></v-skeleton-loader>
    <div v-else-if="user" class="profile-info">
      <div class="mr-2">
        <v-avatar size="50" color="primary">
          <v-icon dark size="30">mdi-account-outline</v-icon>
        </v-avatar>
      </div>
      <div>
        <div>
          <b>{{ user.nome }}</b>
        </div>
        <div>
          <small>
            {{ user.email }}
          </small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProfileHeader',
  props: {
    user: {
      type: Object
    },
    loading: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style scoped>
.profile-header {
  padding: 20px;
  border-radius: 15px;
}
.profile-info {
  display: flex;
}
</style>
